// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oxdyzxgrxgpispnrpwfc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im94ZHl6eGdyeGdwaXNwbnJwd2ZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU1Nzk4MzAsImV4cCI6MjA1MTE1NTgzMH0.UlxPUqBgXBpByBHxWwFdOUwbQoiFLIIkpxWRz84fG9k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);